import React from "react";
import "../css/emsDateRangeEmphasis.css";

const VARIANT_CLASS = {
  hero: "ems-date-range--hero",
  compact: "ems-date-range--compact",
  inline: "ems-date-range--inline",
};

const ARROW = " → ";

function splitForEmphasis(text) {
  const s = String(text);
  if (s.includes(ARROW)) {
    return { parts: s.split(ARROW), join: "arrow" };
  }
  if (s.includes(" to ")) {
    return { parts: s.split(" to "), join: "to" };
  }
  return null;
}

/**
 * Renders a date or range string: date segments bold; "to" or arrow stays visually lighter.
 */
export function EmsDateRangeEmphasis({ children, variant = "hero" }) {
  const text = children == null ? "" : String(children);
  if (!text) return null;

  const wrapClass = ["ems-date-range", VARIANT_CLASS[variant] || VARIANT_CLASS.hero]
    .filter(Boolean)
    .join(" ");

  const split = splitForEmphasis(text);
  if (!split) {
    return (
      <span className={wrapClass}>
        <span className="ems-date-range__seg">{text}</span>
      </span>
    );
  }

  return (
    <span className={wrapClass}>
      {split.parts.map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 &&
            (split.join === "arrow" ? (
              <span className="ems-date-range__arrow" aria-hidden="true">
                →
              </span>
            ) : (
              <span className="ems-date-range__join"> to </span>
            ))}
          <span className="ems-date-range__seg">{part.trim()}</span>
        </React.Fragment>
      ))}
    </span>
  );
}
